module.exports = __webpack_public_path__ + "static/img/exit1.9f32c55a.svg";